import { render, staticRenderFns } from "./edu-education.vue?vue&type=template&id=9f4dc5d4&"
import script from "./edu-education.vue?vue&type=script&lang=js&"
export * from "./edu-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports